/**
 * The locales that have default translation support.
 *
 * @internal
 */
const supportedLocales =
[
  'ar',
  'cs',
  'da',
  'de',
  'el',
  'en-GB',
  'en',
  'es',
  'et',
  'fi',
  'fr',
  'hi',
  'hr',
  'hu',
  'it',
  'ja',
  'ko',
  'lt',
  'lv',
  'nb',
  'nl',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk',
  'sv',
  'tr',
  'vi',
  'zh-CN',
  'zh-TW',
]

module.exports = { supportedLocales };